import { color, global } from 'stylist'
import { css } from '@emotion/core'

export default () =>
  global(
    theme => css`
      body {
        background: ${color('ink', { theme })};
      }
    `
  )



// WEBPACK FOOTER //
// ./src/styles/global.js